export function timeFormat (dateTime = null, fmt = 'yyyy-mm-dd') {
  // 如果为null,则格式化当前时间
  if (!dateTime) dateTime = Number(new Date())
  // 如果dateTime长度为10或者13，则为秒和毫秒的时间戳，如果超过13位，则为其他的时间格式
  if (dateTime.toString().length == 10) dateTime *= 1000
  let date = new Date(dateTime)
  let ret
  let opt = {
    'y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'h+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    's+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    }

  }

  return fmt
}

export function getUpMonth (t) {
  let year = t.substring(0, 4)            //获取当前日期的年
  let month = t.substring(4, 6)              //获取当前日期的月
  let year2 = year
  let month2 = parseInt(month) - 1
  if (month2 == 0) {
    year2 = parseInt(year2) - 1
    month2 = 12
  }

  if (month2 < 10) {
    month2 = '0' + month2
  }
  let m = year2.toString()
  let n = month2.toString()
  let t2 = m + n
  return t2
}

import Vue from 'vue'

export function getPicList (str) {
  if (str) {
    let arr = str.split(',')
    for (let i = 0; i < arr.length; i++) {
      arr[i] = Vue.prototype.$IMG_URL + arr[i]
    }
    return arr
  } else {
    return [require('../assets/images/temp.png')]
  }
}



// WEBPACK FOOTER //
// ./src/utils/util.js